import context from '@/context'
import kebabCase from 'lodash/kebabCase'

export function getChangeItemUrl (scope, changeItemId) {
  return context.isInternalApp()
    ? `/${kebabCase(scope)}/~${changeItemId}`
    : (scope === 'Individuals' ? `/demographics/individuals/~${changeItemId}` : `/demographics/institution-detail/~${changeItemId}`)
}

export function getTargetUrl (scope, targetId) {
  if (context.isInternalApp()) {
    return `/${kebabCase(scope)}/${targetId}`
  }
  return scope === 'Individuals' ? `/demographics/individuals/${targetId}` : `/demographics/institution-detail`
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/urls.js